"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AboutHeader = function AboutHeader(_ref) {
  var classes = _ref.classes,
    title = _ref.title;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "about_title",
    className: classes.titleBody
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.titleText
  }, title))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.whitePadding
  }));
};
var styles = function styles() {
  return {
    header: {
      padding: '45px'
    },
    container: function container(props) {
      return {
        background: props.background
      };
    },
    whitePadding: {
      height: '6px',
      background: 'white'
    },
    titleBody: {
      textAlign: 'center'
    },
    titleText: function titleText(props) {
      return {
        height: '65px',
        width: '252px',
        color: props.titleColor,
        fontFamily: 'Lato',
        fontSize: '35px',
        fontWeight: 'bold'
      };
    }
  };
};
AboutHeader.defaultProps = {
  titleColor: '#0077E3',
  background: '#e7eef5'
};
var _default = (0, _core.withStyles)(styles)(AboutHeader);
exports.default = _default;